import React from 'react'
import ReactRevealText from 'react-reveal-text'

export default class Header extends React.Component {
  constructor() {
    super()
    this.state = { show: false }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ show: true })
    }, 2000)
  }

  render() {
    return (
      <header id="header" style={this.props.timeout ? { display: 'none' } : {}}>
        <div className="logo">
          <span className="icon fa-tree" />
        </div>
        <div className="content">
          <div className="inner">
            <h1>
              <ReactRevealText show={this.state.show} delayMin={0}>
                Developer. Engineer.
              </ReactRevealText>
            </h1>
            <h3> - Powered by Passion & Family - </h3>
            <br />
            <p>// jacob_s_fowles \\</p>
          </div>
        </div>
        <nav>
          <ul>
            <li>
              <a
                href="javascript:;"
                onClick={() => {
                  this.props.onOpenArticle('about')
                }}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                onClick={() => {
                  this.props.onOpenArticle('work')
                }}
              >
                Work
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                onClick={() => {
                  this.props.onOpenArticle('projects')
                }}
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                onClick={() => {
                  this.props.onOpenArticle('social')
                }}
              >
                Social
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                onClick={() => {
                  this.props.onOpenArticle('contact')
                }}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </header>
    )
  }
}

Header.propTypes = {
  onOpenArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Header.js